<template>
  <v-container>
    <v-row v-if="!isEdit">
      <v-col>
        <p class="text-center">REGISTRO EXITOSO</p>
        <v-avatar color="primary" size="100">
          <v-icon dark size="50"> done</v-icon>
        </v-avatar>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <p class="text-center">MODIFICACIÓN EXITOSA</p>
        <v-avatar color="primary" size="100">
          <v-icon dark size="50"> done</v-icon>
        </v-avatar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style></style>
